import { queryClient } from 'App';

import { toNumericId } from 'lib/helpers/utility';
import { appointmentKeys } from 'lib/queries/appointmentKeys';
import { invalidateAllAppointments } from 'lib/queries/appointmentInvalidation';

export default async (data) => {
  const { patient } = data;
  const patientId = toNumericId(patient?.id);

  if (patientId) {
    queryClient.setQueriesData(['patient'], (oldData) => {
      if (!oldData || toNumericId(oldData?.patient?.id) !== patientId) return oldData;
      return {
        ...oldData,
        patient: { ...(oldData?.patient || {}), ...patient }
      };
    });
  }

  // Patch the patient field in every cached appointment detail for this patient.
  const allSingleAppointmentQueries = queryClient
    .getQueryCache()
    .findAll(appointmentKeys.detailsV2());
  for (const query of allSingleAppointmentQueries) {
    queryClient.setQueryData(query.queryKey, (oldData) => {
      if (oldData && toNumericId(oldData?.appointment?.patient?.id) === patientId) {
        return {
          ...oldData,
          appointment: {
            ...oldData?.appointment,
            patient: { ...oldData?.appointment?.patient, ...patient }
          }
        };
      }
      return oldData;
    });
  }

  // Broad refresh of every appointment query — behavior preserved from the
  // pre-factory implementation.
  invalidateAllAppointments(queryClient);
};
